import UpdateMeditationTranslationRequest from '../../../../../Spirit/Admin/Interfaces/Models/MeditationService/UpdateMeditationTranslationRequest';
import CropAndSaveImageRequest from '../../../../../Spirit/Common/FileManager/Models/CropAndSaveImageRequest';

export default class UpdateMeditationRequest  {
	Id?: number = null;
	IsSleep: boolean = false;
	IsPaid: boolean = false;
	UseOnMainDisplay: boolean = false;
	UseBackgroundMusic: boolean = false;
	CategoriesIds: Array<number> = null;
	AnimationId?: string = '';
	Translations: Array<UpdateMeditationTranslationRequest> = null;
	Cover: CropAndSaveImageRequest = null;
	Back: CropAndSaveImageRequest = null;
	constructor(obj?: Partial<UpdateMeditationRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
